export default class ProductNutritionalTable {
    constructor() {
        this.section = document.querySelector('.product-nutritional-table');
        this.btnsOpenModal = this.section.querySelectorAll('.btn-modal-nutritional-table');

        this.ready();
    }

    ready() {
        const modal = this.section.querySelector('.modal-nutritional-table');
        const closeBtn = this.section.querySelector('.close-modal-nutritional-table');
        const productColor = this.section.dataset.color || getComputedStyle(this.section).backgroundColor;
        const homeContentsStrong = document.querySelector('.component-home-contents strong');

        if (homeContentsStrong && productColor) {
            homeContentsStrong.style.color = productColor;
        }

        const ensureActiveVariation = () => {
            const variations = [...modal.querySelectorAll('.product-varitation')];
            const tabs = [...modal.querySelectorAll('[role="tab"]')];
            if (!variations.length || modal.querySelector('.product-varitation.active')) {
                return;
            }
            variations.forEach((el, i) => {
                const active = i === 0;
                el.classList.toggle('active', active);
                el.hidden = !active;
            });
            tabs.forEach((tab, i) => {
                const active = i === 0;
                tab.classList.toggle('active', active);
                tab.setAttribute('aria-selected', active ? 'true' : 'false');
                tab.tabIndex = active ? 0 : -1;
            });
        };

        const decodeVisibleNutritionalImages = () => {
            modal.querySelectorAll('.product-varitation.active img').forEach((img) => {
                if (typeof img.decode === 'function') {
                    img.decode().catch(() => {});
                }
            });
        };

        const openModal = () => {
            modal.classList.toggle('invisible', false);
            modal.classList.toggle('visble', true);

            ensureActiveVariation();

            requestAnimationFrame(() => {
                decodeVisibleNutritionalImages();
            });
        };

        const closeModal = () => {
            modal.classList.toggle('visble', false);
            modal.classList.toggle('invisible', true);
        };

        this.btnsOpenModal.forEach((btn) => {
            btn.addEventListener('click', openModal);
        });

        closeBtn.addEventListener('click', closeModal);
    }
}
if (document.querySelector('.product-nutritional-table')) {
    new ProductNutritionalTable();
}
